// API Client abstraction layer
// This allows us to easily switch between different HTTP clients in the future

import $axios from "./axios";

// Export the axios instance as apiClient
// This abstraction allows us to easily switch to fetch, ky, or other libraries later
export const apiClient = $axios;

// You can also add additional abstraction methods here if needed:
// export const get = (url: string, config?: any) => apiClient.get(url, config);
// export const post = (url: string, data?: any, config?: any) => apiClient.post(url, data, config);
// export const put = (url: string, data?: any, config?: any) => apiClient.put(url, data, config);
// export const del = (url: string, config?: any) => apiClient.delete(url, config);

export default apiClient;
